import {
  StyleSheet,
  Platform,
} from 'react-native';

const primaryColor = Platform.select({
  // ios: '#5462E5',
  // android: '#5462E5',
  // web: '#5462E5',
  ios: '#1FB578',
  android: '#1FB578',
  web: '#1FB578',
});

const primaryColorWithOpacity = Platform.select({
  // ios: '#5462E51A',
  // android: '#5462E51A',
  // web: '#5462E51A',
  ios: '#1FB57840',
  android: '#1FB57840',
  web: '#1FB57840',
});

const primaryColorWeakOpacity = Platform.select({
  // ios: '#5462E51A',
  // android: '#5462E51A',
  // web: '#5462E51A',
  ios: '#1FB5781A',
  android: '#1FB5781A',
  web: '#1FB5781A',
});

const primaryColorMildOpacity = Platform.select({
  // ios: '#5462E5C0',
  // android: '#5462E5C0',
  // web: '#5462E5C0',
  ios: '#1FB578C0',
  android: '#1FB578C0',
  web: '#1FB578C0',
});

const primaryFontRegular = Platform.select({
  ios: 'Rubik',
  android: 'Rubik-Regular',
  web: 'Rubik',
});

const primaryFontSemiBold = Platform.select({
  ios: 'Rubik',
  android: 'Rubik-SemiBold',
  web: 'Rubik',
});

const primaryFontBold = Platform.select({
  ios: 'Rubik',
  android: 'Rubik-Bold',
  web: 'Rubik',
});

const primaryFont300 = primaryFontRegular;
const primaryFont400 = primaryFontRegular;
const primaryFont500 = primaryFontSemiBold;
const primaryFont600 = primaryFontSemiBold;
const primaryFont700 = primaryFontBold;

export default StyleSheet.create({
  paragraph: {
    fontFamily: primaryFontRegular,
    fontSize: 18,
    marginVertical: 16,
    marginHorizontal: 10,
    flexWrap: 'wrap',
    width: '80%',
    alignSelf: 'center',
  },
  info: {
    flex: 1,
    flexDirection: 'row',
    borderRadius: 3,
    borderColor: 'teal',
    borderWidth: 1,
    margin: 10,
    padding: 8,
  },
  infoParagraph: {
    flex: 1,
    fontSize: 18,
    flexWrap: 'wrap',
    alignSelf: 'center',
    color: 'teal',
  },
});

export {
  primaryColor,
  primaryColorWithOpacity,
  primaryColorWeakOpacity,
  primaryColorMildOpacity,

  primaryFontRegular,
  primaryFontSemiBold,
  primaryFontBold,

  primaryFont300,
  primaryFont400,
  primaryFont500,
  primaryFont600,
  primaryFont700,
};
